import { AppConfig } from '../config';
import { fetchWithAuth } from './fetchWithAuth';

interface StreamChatToken {
  token: string;
  apiKey: string;
}

interface ChannelInfo {
  id: string;
  type: string;
  cid: string;
  members: any[];
  created_at: string;
  updated_at: string;
}

interface CreateChannelResponse {
  channel: {
    channel: ChannelInfo;
    messages: any[];
    pinned_messages: any[];
    members: any[];
    membership: any;
    threads: any[];
    duration: string;
  };
  channelId: string;
}

interface UserChannel {
  id: string;
  name?: string;
  unreadCount: number;
  lastMessageAt?: string;
  mcaId?: string;
}

class StreamChatApi {
  async getToken(): Promise<StreamChatToken> {
    return fetchWithAuth(`${AppConfig.apiRoot}stream-chat/token`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then((resp) => {
      if (resp.status !== 200) {
        throw new Error('Failed to get Stream Chat token');
      }
      return resp.json();
    });
  }

  async createMcaUnderwritingChannel(mcaId: string): Promise<CreateChannelResponse> {
    return fetchWithAuth(`${AppConfig.apiRoot}stream-chat/channels/mca-underwriting/${mcaId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then((resp) => {
      if (resp.status !== 200) {
        throw new Error('Failed to create MCA underwriting channel');
      }
      return resp.json();
    });
  }

  async getChannelInfo(channelId: string): Promise<ChannelInfo> {
    return fetchWithAuth(`${AppConfig.apiRoot}stream-chat/channels/${channelId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then((resp) => {
      if (resp.status !== 200) {
        throw new Error('Failed to get channel info');
      }
      return resp.json();
    });
  }

  async getUserChannels(): Promise<UserChannel[]> {
    return fetchWithAuth(`${AppConfig.apiRoot}stream-chat/user/channels`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then((resp) => {
      if (resp.status !== 200) {
        throw new Error('Failed to get user channels');
      }
      return resp.json();
    });
  }
}

export const streamChatApi = new StreamChatApi();
